'use client'

import { useTranslate } from '../../hooks'
import { Row, Typography } from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'
import type { AdvancedTradeBoxOrderType } from './advanced-trade-box.types'

interface AdvancedTradeBoxFeeDisplayProps {
  orderType: AdvancedTradeBoxOrderType
}

export const AdvancedTradeBoxFeeDisplay = (
  props: AdvancedTradeBoxFeeDisplayProps,
) => {
  const { orderType } = props
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  if (!isDesktop) {
    return null
  }

  return (
    <Row className='justify-between mb-md'>
      <Typography size='xs' color='text-neutral-surface-80'>
        {orderType === 'market' ? t('order_approximate_fee') : t('order_fee')}
      </Typography>
      <div className='flex items-center gap-xs'>
        <Typography
          size='xs'
          color='text-neutral-surface-60'
          className='line-through'
        >
          ۷۱٬۰۰۰
        </Typography>
        <Typography size='xs' color='text-neutral-surface-60'>
          {'←'}
        </Typography>
        <Typography size='xs' color='text-neutral-surface-100'>
          ۳۵٬۵۰۰
        </Typography>
        <Typography size='xs' color='text-neutral-surface-60'>
          {t('currency_toman')}
        </Typography>
      </div>
    </Row>
  )
}
